import { render } from "./ChatSubjectInput.vue?vue&type=template&id=54b18ed9&scoped=true"
import script from "./ChatSubjectInput.vue?vue&type=script&lang=js"
export * from "./ChatSubjectInput.vue?vue&type=script&lang=js"

import "./ChatSubjectInput.vue?vue&type=style&index=0&id=54b18ed9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b18ed9"]])

export default __exports__